/**
 * Mock audience targets for ShareProjectModal (PRJ-04 / LLD UC 11).
 *
 * Dropdown options grouped by source type. BE team will replace with the
 * real teacher/class directory after MobiEdu SSO integration (BE-V2-01).
 *
 * W-8 FIX: The classes list MUST include exact `sharedBy` strings used by
 * the DP-08 mock shared-projects.js (e.g. "Nhóm 5 - Lớp 8B") so audience
 * dropdown options round-trip with the labels users see in
 * SharedProjectsModal. Group-level (Nhóm X - Lớp Y) and class-level
 * (Lớp Y) coexist — when a user shares to a class they can pick the
 * precise scope.
 */

const SHARE_AUDIENCES = {
    teachers: [
        {id: 'teacher-lan', name: 'Cô Lan - Toán'},
        {id: 'teacher-hung', name: 'Thầy Hùng - Khoa học'},
        {id: 'teacher-mai', name: 'Cô Mai - Tin học'}
    ],
    classes: [
        {id: 'class-9a1', name: 'Lớp 9A1'},
        {id: 'class-8b-group-5', name: 'Nhóm 5 - Lớp 8B'},
        {id: 'class-8b', name: 'Lớp 8B'},
        {id: 'class-7c', name: 'Lớp 7C'}
    ],
    community: {
        id: 'community-mbf',
        name: 'Công khai - Cộng đồng MBF'
    }
};

export default SHARE_AUDIENCES;
